import React, { FunctionComponent } from 'react'
import { FormattedMessage } from 'react-intl'

import { useTheme } from 'styled-components/native'

import { InPersonStroke } from '../../atoms/icons/InPersonStroke'
import { CareOptionCard } from '../../templates/careOptionCard/CareOptionCard'
import { tID } from '../../utils/utils'

export interface CareNavigatorCarelonDirectoryOptionCardProps {
  onPress: (() => void) | undefined
}

export const CareNavigatorCarelonDirectoryOptionCard: FunctionComponent<
  CareNavigatorCarelonDirectoryOptionCardProps
> = ({ onPress }) => {
  const { colors } = useTheme()

  const optionHeader = (
    <FormattedMessage
      defaultMessage='Carelon Behavioral Health'
      description='Title for Carelon Behavioral Health provider directory link on Care Navigator contact page'
    />
  )

  const optionDescription = (
    <FormattedMessage
      defaultMessage='You also have access to prescribing providers in Carelon’s network.'
      description='Description for Carelon Behavioral Health provider directory link explaining access to prescribing providers'
    />
  )

  return (
    <CareOptionCard
      onPress={onPress}
      optionIcon={<InPersonStroke size={24} fillColor={colors.textSecondary} />}
      optionHeader={optionHeader}
      optionDescription={optionDescription}
      useExternalLinkIcon={true}
      testId={tID('CareNavigatorCarelonDirectoryOptionCard')}
    />
  )
}
